<template>
  <div>
    <ul class="root" v-if="comments && comments.length !== 0">
      <li
        class="review"
        v-for="(item, index) in comments"
        :key="index"
        v-show="index < 3 || isExpand"
      >
        <img src="@/assets/reviewuser.svg" />
        <div>
          <p class="content">
            {{ item.Content }}
          </p>
          <div class="stars">
            <span
              v-for="(number, index) in [1, 2, 3, 4, 5]"
              :key="index"
              :class="{ colored: number <= item.Reputation }"
              >★</span
            >
          </div>
        </div>
      </li>
      <li class="expandIcon" @click="onClick" v-if="comments.length > 3">
        <img :class="{ isExpand: isExpand }" src="@/assets/chevron.svg" />
      </li>
    </ul>
    <div v-else>口コミはまだありません</div>
  </div>
</template>

<script>
export default {
  name: "show-review-area",
  props: {
    comments: {
      type: Array,
      require: true,
    },
  },
  data() {
    return {
      isExpand: false,
    };
  },
  methods: {
    onClick() {
      this.isExpand = !this.isExpand;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.root {
  padding: 0;
}
.review {
  display: flex;
  img {
    width: 24px;
    margin-right: 0.75rem;
  }
  p {
    margin: 0.25rem 0;
  }
  .content {
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    font-size: 0.8rem;
  }
  .stars {
    display: flex;
    flex-direction: row;
    font-size: 0.9rem;
    .colored {
      color: #ffe42e;
    }
  }
}
.isExpand {
  transform: rotate(180deg);
}

.expandIcon {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/DropSpotSelectModal/ReviewArea.vue